var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-info" }, [
    _c(
      "div",
      { staticClass: "page-info-icon" },
      [_c("f-sprite-icon", { attrs: { "icon-link": _vm.icon } })],
      1
    ),
    _vm.title
      ? _c("h2", {
          staticClass: "title",
          domProps: { innerHTML: _vm._s(_vm.title) }
        })
      : _vm._e(),
    _vm.subtitle
      ? _c("p", { staticClass: "description" }, [
          _vm._v("\n    " + _vm._s(_vm.subtitle) + "\n  ")
        ])
      : _vm._e(),
    _vm.$slots.default
      ? _c("p", { staticClass: "description" }, [_vm._t("default")], 2)
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }